import { ALL_CATEGORIES } from './allCategories'
import { FILTER_OPTIONS, SORT_TABS } from './trademark'

/** 找商标页每页条数，对齐同行端列表默认 100 */
export const SEARCH_PAGE_SIZE = 100

export const SEARCH_TYPES = [
  { label: '商标名称', value: 1 },
  { label: '注册号', value: 3 },
  { label: '小项名称', value: 4 }
]

export const SEARCH_HERO_PLACEHOLDER = '请输入您喜欢的商标名或字词'

/** 对齐十象交易页热门行业 */
export const SEARCH_HOT_INDUSTRIES = [
  { label: '不限', category: '' },
  { label: '服装鞋帽', category: '25' },
  { label: '酒饮', category: '33' },
  { label: '食品', category: '29' },
  { label: '广告', category: '35' },
  { label: '化妆品', category: '3' },
  { label: '餐饮', category: '43' },
  { label: '电子产品', category: '9' },
  { label: '灯具厨具', category: '11' },
  { label: '医药', category: '5' },
  { label: '家具', category: '20' },
  { label: '教育', category: '41' },
  { label: '皮具箱包', category: '18' },
  { label: '茶', category: '30' }
]

export const SEARCH_PRICE_PRESETS = [
  { label: '不限', value: '', min: 0, max: 0 },
  { label: '8000以下', value: '0-8000', min: 0, max: 8000 },
  { label: '5000以下', value: '0-5000', min: 0, max: 5000 },
  { label: '5000-1万', value: '5000-10000', min: 5000, max: 10000 },
  { label: '8000-15000', value: '8000-15000', min: 8000, max: 15000 },
  { label: '1万-3万', value: '10000-30000', min: 10000, max: 30000 },
  { label: '3万以上', value: '30000+', min: 30000, max: 0 }
]

export const SEARCH_FILTER_OPTIONS = {
  categories: [
    { label: '全部类别', value: '' },
    ...ALL_CATEGORIES.map(cat => ({
      label: `${String(cat.id).padStart(2, '0')}类 ${cat.name}`,
      value: String(cat.id)
    }))
  ],
  statuses: FILTER_OPTIONS.statuses,
  prices: SEARCH_PRICE_PRESETS,
  sorts: FILTER_OPTIONS.sorts
}

export const SEARCH_SORT_TABS = SORT_TABS

export function parseCategoryFilter(value) {
  if (!value) return []
  return String(value)
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
}

export function formatCategoryFilter(ids) {
  return ids
    .filter(Boolean)
    .sort((a, b) => Number(a) - Number(b))
    .join(',')
}

export function parseGroupFilter(value) {
  if (!value) return []
  if (Array.isArray(value)) {
    return value.map(item => String(item).trim()).filter(Boolean)
  }
  return String(value)
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
}

export function formatGroupFilter(codes) {
  return codes.filter(Boolean).join(',')
}

export function filterGroupsByCategories(groupCodes, categoryIds) {
  if (!categoryIds.length) return []
  const prefixes = new Set(
    categoryIds.map(id => String(id).padStart(2, '0'))
  )
  return groupCodes.filter(code => prefixes.has(String(code).slice(0, 2)))
}

export function patchCategorySelection(current, categoryId, multi) {
  if (!categoryId) {
    return ''
  }

  const id = String(categoryId)

  if (!multi) {
    return String(current) === id ? '' : id
  }

  const ids = parseCategoryFilter(current)
  const index = ids.indexOf(id)
  if (index >= 0) {
    ids.splice(index, 1)
  } else {
    ids.push(id)
  }
  return formatCategoryFilter(ids)
}

export function createEmptySearchFilters() {
  return {
    keyword: '',
    searchType: 1,
    category: '',
    group: '',
    sameNameMulti: false,
    status: '',
    price: '',
    priceMin: '',
    priceMax: '',
    sort: 'default',
    activeSort: 'default'
  }
}
